import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { NavService } from '../../../../_services/_nav.service';
import moment from 'moment';
import 'moment/locale/es';
import { ProspectoService } from '../../../../_services/prospecto.service';
import { SolicitudEstadoHistoricoService } from '../../../../_services/solicitud-estado-historico.service';

@Component( {
  selector: 'app-widget-prospecto-perfil-mes',
  templateUrl: 'widget-prospecto-perfil-mes.component.html'
} )

export class WidgetProspectoPerfilMesComponent {


  @Input()
  set idOficina( idOficina: string ) {
    this._idOficina = idOficina;
    if ( this._idOficina !== undefined ) {
      this.filtrar();
    }
  }

  get idOficina(): string {
    return this._idOficina;
  }

  @Input()
  set idAgrupacion( idAgrupacion: string ) {
    this._idAgrupacion = idAgrupacion;
    if ( this._idAgrupacion !== undefined ) {
      this.filtrar();
    }
  }

  get idAgrupacion(): string {
    return this._idAgrupacion;
  }

  @Input()
  set refrescar( refrescar: boolean ) {
    this._refrescar = refrescar;
    if ( this._refrescar ) {
      this.filtrar();
    }
  }

  get refrescar(): boolean {
    return this._refrescar;
  }

  _refrescar: boolean;


  _idAgrupacion: string;

  _idOficina: string;

  @Output() cargando: EventEmitter<boolean> = new EventEmitter();

  lisFiltros: SelectItem[] = [];

  idFiltro = 'PROS';

  datGrafico: any;

  opciones: any;

  carInformacion = true;

  constructor( private navServicio: NavService,
               private proServicio: ProspectoService,
               private solHistorialEstadoAnalizamos: SolicitudEstadoHistoricoService ) {
    this.lisFiltros.push( { label: this.navServicio.buscarMensaje( 'INICIO_DASHBOARD.LBL_PROSPECTOS' ), value: 'PROS' } );
    this.lisFiltros.push( { label: this.navServicio.buscarMensaje( 'INICIO_DASHBOARD.LBL_PERFILADOS' ), value: 'PERF' } );
    this.lisFiltros.push( { label: this.navServicio.buscarMensaje( 'INICIO_DASHBOARD.LBL_DESEMBOLSADOS' ), value: 'DESEM' } );
  }

  filtrar() {
    this.carInformacion = true;
    this.cargando.emit( true );
    const a = this.lisFiltros.find( x => x.value == this.idFiltro );
    if ( a.value == 'PROS' ) {
      this.proServicio.widgetMesAnio( this._idAgrupacion, this._idOficina ).subscribe( listado => {
        this.generarGrafico( listado, a );
      } );
    } else if ( a.value == 'PERF' ) {
      this.solHistorialEstadoAnalizamos.widgetMesAnio( this._idAgrupacion, this._idOficina, 'ESTPER' ).subscribe( listado => {
        this.generarGrafico( listado, a );
      } );
    } else {
      this.solHistorialEstadoAnalizamos.widgetMesAnio( this._idAgrupacion, this._idOficina, 'ESTDES' ).subscribe( listado => {
        this.generarGrafico( listado, a );
      } );
    }
  }

  generarGrafico( registros: any[], a: any ) {
    this.cargarOpcionesGraficos( a );
    const informacion = this.ordenarDatos( registros );
    const labels = [];
    const data = [];
    informacion.map( ( s: any ) => {
      labels.push( moment( s.mes, 'MM' ).format( 'MMMM' ) );
      data.push( s.valor );
    } );
    this.datGrafico = {
      labels: labels,
      datasets: [
        {
          label: a ? a.label : '',
          backgroundColor: [ '#9CCC65', '#333333', '#C6C6C6', '#F2F5A9', '#BDBDBD', '#FAAC58', '#2EFE64', '#F7D358', '#8A0829', '#868A08', '#088A08', '#86B404' ],
          borderColor: '#7CB342',
          data: data
        }
      ]
    };
    this.carInformacion = false;
    this.cargando.emit( false );
  }

  ordenarDatos( registros: any[] ) {
    registros.sort( function( a, b ) {
      if ( a.anio == b.anio ) {
        return (a.mes < b.mes) ? -1 : (a.mes > b.mes) ? 1 : 0;
      } else {
        return (a.anio < b.anio) ? -1 : 1;
      }
    } );
    return registros;
  }

  cargarOpcionesGraficos( a: any ) {
    this.opciones = {
      legend: {
        display: false
      },
      scales: {
        yAxes: [
          { scaleLabel: { display: true, labelString: a ? a.label : '' } }
        ],
        xAxes: [
          {
            scaleLabel: { display: true, labelString: this.navServicio.buscarMensaje( 'LBL_MESES' ) }
          },

        ]
      }
    };
  }


}
